import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
/*teste*/
import Header from "./components/Header";
import Footer from "./components/Footer";
import SmoothScroll from "./components/SmoothScroll";

import Home from "./pages/Home";
import Products from "./pages/Products";
import About from "./pages/About";
import Projects from "./pages/Projects";
import Contact from "./pages/Contact";
import Partners from "./pages/Partners";
import NotFound from "./pages/Error404";
import Maintenance from "./pages/Maintenance";
import Clients from "./pages/Projects_Clients";
import SuccessStories from "./pages/Projects_SuccessStories";

import { LanguageProvider } from "./context/LanguageContext";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) {
      window.__lenis.scrollTo(0, { immediate: true, force: true });
    } else {
      window.scrollTo({ top: 0, behavior: "instant" });
    }
  }, [pathname]);
  return null;
}

// 2. Componente de conteúdo que tem acesso ao Router
function AppContent() {
  const location = useLocation();
  const validRoutes = ["/", "/products", "/about", "/projects", "/contact", "/partners", "/maintenance", "/clients", "/sucessstories"];
  const isNotFound = !validRoutes.includes(location.pathname);

  return (
    // 'min-h-screen' garante que o layout ocupa sempre o ecrã todo
    <div className="App flex flex-col min-h-screen bg-[#0A0A0A] text-white">
      <SmoothScroll />
      <ScrollToTop />
      
      <Header />
      <main className={`relative z-[1] flex-grow ${isNotFound ? "h-[calc(100vh-160px)] flex flex-col items-center justify-center" : ""}`}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/products" element={<Products />} />
          <Route path="/about" element={<About />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/partners" element={<Partners />} />
          <Route path="*" element={<NotFound />} />
          <Route path="/maintenance" element={<Maintenance />} />
          <Route path="/clients" element={<Clients />} />
          <Route path="/sucessstories" element={<SuccessStories />} />
        </Routes>
      </main>
      
      <Footer />
    </div>
  );
}

// 3. Componente principal
function App() {
  useEffect(() => {
    document.title = "WSBP Electronics";
  }, []);

  return (
    <LanguageProvider>
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
